export default __webpack_public_path__ + "static/media/venus-bg-effect-3.a99b3e88.svg";